"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInitSellingResourceInstruction = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const initSellingResourceStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['masterEditionBump', beet.u8],
    ['vaultOwnerBump', beet.u8],
    ['maxSupply', beet.coption(beet.u64)],
], 'InitSellingResourceInstructionArgs');
const initSellingResourceInstructionDiscriminator = [56, 15, 222, 211, 147, 205, 4, 145];
function createInitSellingResourceInstruction(accounts, args) {
    const { store, admin, sellingResource, sellingResourceOwner, resourceMint, masterEdition, metadata, vault, owner, resourceToken, } = accounts;
    const [data] = initSellingResourceStruct.serialize({
        instructionDiscriminator: initSellingResourceInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: store,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: admin,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: sellingResource,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: sellingResourceOwner,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: resourceMint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: masterEdition,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: metadata,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: vault,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: owner,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: resourceToken,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('SaLeTjyUa5wXHnGuewUSyJ5JWZaHwz3TxqUntCE9czo'),
        keys,
        data,
    });
    return ix;
}
exports.createInitSellingResourceInstruction = createInitSellingResourceInstruction;
//# sourceMappingURL=initSellingResource.js.map